import { Component, OnInit, ViewChild, NO_ERRORS_SCHEMA } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { AdminPost } from "../model/notes";
import { NoteService } from "../services/note.service";
import { UserService } from "../../user/service/user.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
import { AuthServiceService } from "app/component/service/auth-service.service";

@Component({
  selector: "app-user-post",
  templateUrl: "./admin-post.component.html",
  styleUrls: ["./admin-post.component.css"]
})
export class AdminPostComponent implements OnInit {
  ckeConfig: any;
  mycontent: string;
  log: string = "";
  AppointmentDoctorId: string = "0";
  Users: Array<any> = [];
  srvData: AdminPost = new AdminPost(null, "", "", null, "", "", 2);
  loading: boolean = false;
  listLoading: boolean = false;
  message: string = "";
  isAdd: boolean = true;
  AdminPosts: AdminPost[];
  selectedObject: AdminPost;
  user: any;
  filesData: any[];
  text: string;
  profilePic: any;
  isSuperAdmin = false;
  constructor(
    private _sharedService: SharedService,
    private _notesService: NoteService,
    private authService: AuthServiceService,
    private usrSrv: UserService
  ) {
    this.isAdd = true;

    this.mycontent = `<p>My html content</p>`;
  }

  getAdminPostDetail(): void {
    this.listLoading = true;
    this._notesService.getAdminPost().subscribe(
      data => {
        this.listLoading = false;
        this.AdminPosts = data;
      },
      error => {}
    );
  }
  getUsers(): void {
    this.usrSrv.getUsersDetail().subscribe(
      data => {
        this.Users = data; //.filter((usr) => usr.UserRoleId < 3 )
      },
      error => {}
    );
  }
  clearData(): void {
    this.srvData.PostId = null;
    this.srvData.HeaderText = "";
    this.srvData.Text = "";
    this.srvData.ImagePath = "";
    this.srvData.Days = 2;
    this.isAdd = true;
    this.profilePic = "";
    this.text = "";
  }

  cancelData(): void {
    if (this.isAdd) {
      this.clearData();
    } else {
      this._sharedService.emitDialog(
        true,
        "Cancel",
        ActionMessage.CANCEL.toString(),
        true,
        DialogAction.CANCEL.toString(),
        "ACTION"
      );
    }
  }
  editAdminPost(srvEditObject: AdminPost): void {
    this.isAdd = false;
    this.srvData = Object.assign(Object.create(srvEditObject), srvEditObject);
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));

    this.getUsers();
    this.getAdminPostDetail();
    this._sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "PROMOTION"
      ) {
        this.delete();
      } else {
        this.clearData();
      }
    });

    this.getUsers();
    if (this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
    }
  }

  loadAdminPost() {
    this.getAdminPostDetail();
  }
  saveAdminPost(): void {
    this.loading = true;
    this._notesService.dataPost = this.srvData;
    if (this.isAdd) {
      this._notesService.dataPost.UserId = parseInt(this.AppointmentDoctorId);

      this.addAdminPost();
    } else {
      this.updateAdminPost();
    }
  }

  updateProfilePic(id: number, userid: number, bookingNumber: string) {
    this._notesService.dataPost.PostId = id;
    this._notesService.dataPost.UserId = userid;
    this.filesData = [];

    this.filesData.push(this.profilePic);
    this._notesService.profilePic = this.filesData;
    this._notesService.saveAdminPostPic().subscribe(
      data => {
        this.loading = false;
        this.profilePic = null;
        this.text = "";
        this.clearData();
        this.getAdminPostDetail();
      },
      error => {
        this.loading = false;
        if (JSON.parse(error._body).Message === undefined) {
          this.message = error._body;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.clearData();
        this.getAdminPostDetail();
      }
    );
  }

  addAdminPost(): void {
    this._notesService.saveAdminPost().subscribe(
      data => {
        this.loading = false;
        this.message = "User Post " + ActionMessage.SAVESUCCESS.toString();

        if (this.profilePic != undefined) {
          this.updateProfilePic(data.PostId, data.UserId, "");
        } else {
          this.getAdminPostDetail();
          this.clearData();
        }
        this.hideMessage();
      },
      error => {
        this.loading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  updateAdminPost(): void {
    this._notesService.updateAdminPost().subscribe(
      data => {
        this.loading = false;
        this.message = "User Post " + ActionMessage.UPDATESUCCESS.toString();

        if (this.profilePic != undefined) {
          this.updateProfilePic(this.srvData.PostId, this.srvData.UserId, "");
        } else {
          this.getAdminPostDetail();
          this.clearData();
        }

        this.hideMessage();
      },
      error => {
        this.loading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  deleteImage(data: AdminPost) {
    this.srvData.ImagePath = "";
    this._notesService.dataPost = this.srvData;
    this.updateAdminPost();
  }
  hideMessage(): void {
    setTimeout(() => {
      this.message = "";
    }, 1000);
  }
  delete(): void {
    this.listLoading = true;
    this._notesService.deleteAdminPost(this.selectedObject).subscribe(
      data => {
        this.listLoading = false;
        this.message = "User Post " + ActionMessage.DELETESUCCESS.toString();
        this.clearData();
        this.getAdminPostDetail();
        this.hideMessage();
      },
      error => {
        this.listLoading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  onChangeFile(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    this.profilePic = files[0];
    this.text = files[0].name;
  }
  deletAdminPost(org: AdminPost): void {
    this.selectedObject = org;
    this._sharedService.emitDialog(
      true,
      "Delete",
      ActionMessage.DELETE.toString(),
      true,
      DialogAction.DELETE.toString(),
      "PROMOTION"
    );
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  onChange($event: any): void {
    console.log("onChange");
    //this.log += new Date() + "<br />";
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/admin-post/admin-post.component.ts